// ProtectedRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const isAuthCallbackNow = (location) => {
  // OAuth PKCE (Supabase): ?code=... (&state=...)
  const search = new URLSearchParams(location.search);
  const hasCode = search.has('code');

  // Magic link / recovery flow (Supabase): #access_token=...
  const hasAccessTokenHash =
    typeof window !== 'undefined' && window.location.hash.includes('access_token');

  // In rari casi alcuni provider appendono query ?access_token / ?refresh_token
  const hasAccessTokenQuery = search.has('access_token') || search.has('refresh_token');

  // Se hai una route dedicata tipo /auth/callback puoi aggiungerla:
  const isCallbackPath = location.pathname.startsWith('/auth/callback');

  return hasCode || hasAccessTokenHash || hasAccessTokenQuery || isCallbackPath;
};

const ProtectedRoute = ({ children }) => {
  const { t } = useTranslation();
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // 1) Durante l'inizializzazione auth → niente redirect
  if (loading) {
    return <div>{t('common.loading')}</div>;
  }

  // 2) Durante il callback OAuth/magic-link → lascia passare
  if (isAuthCallbackNow(location)) {
    return children;
  }

  // 3) Se non autenticato, porta al login e conserva la destinazione
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 4) Altrimenti ok
  return children;
};

export default ProtectedRoute;
